import { AeSystemOverlay } from '#app/routes/mocra+/_form+/components/ae-systems/overlay.tsx'
import { type AeSystemDraft } from '#app/routes/mocra+/_form+/components/ae-systems/types.ts'

type Props = {
	open: boolean
	onOpenChange: (open: boolean) => void
	onSubmit: (draft: AeSystemDraft) => void
	initialValue: AeSystemDraft
	onClosed?: () => void
	onCancel?: () => void
}

export function AeSystemEditOverlay({
	open,
	onOpenChange,
	onSubmit,
	initialValue,
	onClosed,
	onCancel,
}: Props) {
	return (
		<AeSystemOverlay
			mode="edit"
			open={open}
			onOpenChange={onOpenChange}
			onSubmit={onSubmit}
			initialValue={initialValue}
			onClosed={onClosed}
			onCancel={onCancel}
		/>
	)
}
